import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import type { TCredenciaisLogin, TLoginErrorResponse } from '@/features/user/interfaces'
import { LoginService } from '@/features/user/services'
import { userKeys } from '@/features/user/utils'
import type { TUsuarioLogado } from '@/shared/interfaces/user'

export const useLogin = () => {
  const mutation = useMutation<
    TUsuarioLogado,
    AxiosError<TLoginErrorResponse, TLoginErrorResponse>,
    TCredenciaisLogin,
    unknown
  >({
    mutationKey: userKeys.login(),
    mutationFn: async (credentiais: TCredenciaisLogin) =>
      new LoginService().execute(credentiais).then((res) => res.data),
  })
  return mutation
}
